import { useState, useEffect, useRef } from 'react';

export const useWebSocketFetcher = (wsUrl: string) => {
  const [ streamData, setStreamData ] = useState<string[]>([]);
  const [ isStreaming, setIsStreaming ] = useState<boolean>(false);
  const wsRef = useRef<WebSocket | null>(null);

  const connectWebSocket = (endpoint: string, body: Record<string, any>) => {
    if (isStreaming) {
      return;
    }

    setIsStreaming(true);
    setStreamData([]);

    const url = `${wsUrl}${endpoint}`; // Ensure the WebSocket endpoint is correct
    const ws = new WebSocket(url);

    wsRef.current = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify(body));
    };

    ws.onmessage = (event) => {
      setStreamData((prev) => [ ...prev, event.data ]);
    };

    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    ws.onclose = () => {
      setIsStreaming(false);
    };
  };

  const closeWebSocket = () => {
    if (wsRef.current) {
      wsRef.current.close();
      wsRef.current = null;
    }
  };

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      closeWebSocket();
    };
  }, []);

  return { streamData: streamData, isStreaming: isStreaming, connectWebSocket: connectWebSocket, closeWebSocket: closeWebSocket };
};
